import React from 'react';

interface SpecsFeaturesAccordionProps {
    isExpanded?: boolean;
}

interface SpecsFeaturesAccordionState {
    isExpanded: boolean;
}

export default class SpecsFeaturesAccordion extends React.Component<SpecsFeaturesAccordionProps, SpecsFeaturesAccordionState> {
    constructor(props:SpecsFeaturesAccordionProps) {
        super(props);

        this.state = {
            isExpanded: props.isExpanded || false
        }
    }

    toggle(e) {
        if(e) e.preventDefault();

        if(e.target.className.indexOf('specs__groupTitle') === -1) return;

        const isExpanded = !this.state.isExpanded;
        this.setState({isExpanded});
    }

    render() {
        const { isExpanded } = this.state;
        const { children } = this.props;

        return (
            <div className={`specs__group ${isExpanded ? 'specs__group--expanded' : ''}`} onClick={(e) => this.toggle(e)}>
                {children}
            </div>
        )
    }
}
